import { useAccount } from '@lib/context/account-context'
import Spinner from '@modules/common/icons/spinner'
import React, { useEffect } from 'react'
import AccountNav from '../components/account-nav'
import { Box, Container } from '@chakra-ui/react'

const AccountLayout: React.FC = ({ children }) => {
  const { customer, retrievingCustomer, checkSession } = useAccount()

  useEffect(() => {
    checkSession()
  }, [checkSession])

  if (retrievingCustomer || !customer) {
    return (
      <div className="flex items-center justify-center w-full min-h-[640px] h-full text-gray-900">
        <Spinner size={36} />
      </div>
    )
  }

  return (
    <Box bg="#f9fafb" py={12}>
      <Container>
        <div className="flex flex-col flex-1 h-full bg-white">
          <div className="grid grid-cols-1 small:grid-cols-[240px_1fr] px-8 py-6 py-12 ">
            <div>
              <AccountNav />
            </div>
            <div className="flex-1">{children}</div>
          </div>
        </div>
      </Container>
    </Box>
  )
}

export default AccountLayout
